module.exports = __webpack_public_path__ + "static/projectsBg-91a8f5b77447f7736782244ad6821a4f.jpg";